import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map, take, exhaustMap} from "rxjs";
import {AuthenticationService} from './authentication.service';
import {ActionResult, EventPaymentSettings} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class EventPaymentSettingsService {

  constructor(private http: HttpClient, private authService: AuthenticationService, private environmentService:EnvironmentService) {
  }

  fetchEventPaymentSettingsById(eventId: number): Observable<EventPaymentSettings | null> {
    return this.http.post<ActionResult<EventPaymentSettings>>(this.environmentService.getApiUrl() + "/api/events/paymentsettings/fetch", eventId)
      .pipe(
        map((value: ActionResult<EventPaymentSettings>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return null;
          }
        })
      );
  }

  updateEventPaymentSettings(paymentSettings: EventPaymentSettings, onSuccess: () => void, onError: () => void) {
    this.authService.jwtResponse.pipe(take(1), exhaustMap(() => {
      return this.http.post<ActionResult<boolean>>
      (this.environmentService.getApiUrl() + "/api/events/paymentsettings/update", paymentSettings);
    })).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
      } else {
        onError();
      }
    });
  }
}
